module.exports = "https://redage.akamaized.net/src/views/player/help/images/post.jpg";